import { makeEndpointFns } from '../fns';
import { ListAccountsQuery, ListAccountsResponse } from '@/user/user';

const { GET } = makeEndpointFns('storeManager');

export const user = {
    /** Returns a paginated list of user accounts with their roles */
    listAccounts: GET('api/v1/accountManager/getAccounts/{skip}/{limit}', ListAccountsResponse, {
        query: ListAccountsQuery,
    }),
};
